import {
  AUTH_TOKEN_SUCCESS,
  AUTH_TOKEN_FAILED,
  RESET_AUTH_TOKEN,
  LOADING_AUTH_TOKEN,
  NETWORK_ERROR_AUTH_TOKEN,
} from "../types/index";

const initialState = {
  isLoading: false,
  success: false,
  network: false,
  failed: false,
  data: {},
  message: "",
  networkError: "",
};

export default (state = initialState, action) => {
  switch (action.type) {
    case LOADING_AUTH_TOKEN:
      return {
        ...state,
        isLoading: true,
        success: false,
        failed: false,
        network: false,
        data: {},
        message: "",
        networkError: "",
      };
    case AUTH_TOKEN_FAILED:
      return {
        ...state,
        isLoading: false,
        success: false,
        failed: true,
        network: false,
        data: action.payload,
        message: "",
        networkError: "",
      };
    case AUTH_TOKEN_SUCCESS:
      return {
        ...state,
        isLoading: true,
        success: true,
        failed: false,
        network: false,
        data: action.payload,
        message: "",
        networkError: "",
      };
    case NETWORK_ERROR_AUTH_TOKEN:
      return {
        ...state,
        isLoading: false,
        success: false,
        failed: false,
        network: true,
        data: {},
        message: "",
        networkError: "",
      };
    case RESET_AUTH_TOKEN:
      return (state = initialState);
    default:
      return state;
  }
};
